import moment from "moment/moment";
import {MessageBox} from 'element-ui';
import getErrorMsg from '@/language/getErrorMessage';
import replaceBracket from '@/utils/replaceBracket';
import getI18n from '@/vueI18n/getI18n';

/**
 * 发信邮件错误弹框
 */
export function sendMailErrorAlert(res) {
  let msg = "";
  if (res.data.hasOwnProperty("data") && res.data.data.hasOwnProperty("invalidAddress") && res.data.data.invalidAddress.length > 0) {
    msg = res.data.data.invalidAddress[0];
  }
  msg = msg != "" ? getErrorMsg(res.data).replace("{invalidAddress}", "&lt;"+ msg +"&gt;") : getErrorMsg(res.data);
  let alertHtml = '<h3 style="line-height:24px; color: #24324c;">' + replaceBracket(msg) + '</h3>';
  if ((res.data.code >= 2051 && res.data.code <= 2060) || (res.data.code >= 2851 && res.data.code <= 2900)) {
    alertHtml += '<div style="font-size:12px; margin:20px 20px 20px 0; line-height:21px; color:#24324c;">code: ' + res.data.code + ', host: ' + res.data.host
      + ', time: ' + moment.unix(res.data.time / 1000).format("YYYY-MM-DD HH:mm:ss") + ', traceId: ' + res.data.traceId + ' </div>';
  }
  MessageBox.alert(alertHtml, getI18n.t('wm_lang_c45357'), {dangerouslyUseHTMLString: true});
}



// WEBPACK FOOTER //
// ./src/utils/sendMailAlert.js